import formatPropertyAddress from 'lib/formatters/formatPropertyAddress';

export default formatPropertyAddress;
